import { digitalTemplateType, sidebarTabKeyEnum } from '../utils/constants';
import { getAllowedIcons, getSidebarStoreData } from './selectors';
import { getCurrentBackgroundDesignPanelShownFlag, getCurrentGuideModeCheck } from '../main/selectors';
import { onlyOneSentimentCheck, onlyOneSloganCheck, onlyOneVerseCheck } from '../userimage/selectors';
import { selectImageForNonDigital, unSelectAllImage, unSelectAllText } from '../canvas/actions';

import { changeSidebarTabKey } from './actions';
import { getHasOneImprintColorOnly } from '../imprintarea/selectors';
import { isMobileOnly } from 'react-device-detect';
import { nextGenSidebarTabKeyEnum } from '../nextgen/constants';
import { selectFirstLineText } from '../text/logics';
import { studioItemType as studioItemTypeEnum } from '../main/constants';

export const checkAndAutoOpenTabAsync = () => (dispatch, getState) => {
  const state = getState();
  const storeData = getSidebarStoreData(state);
  const allowedIcons = getAllowedIcons(state);
  const isGuideMode = isMobileOnly ? getCurrentGuideModeCheck(state) : false;
  const shown = getCurrentBackgroundDesignPanelShownFlag(state);

  const { studioItemType } = storeData;
  const isDigital = studioItemType === studioItemTypeEnum.digital;
  if (isDigital && isMobileOnly && !shown && allowedIcons.find((icon) => icon === sidebarTabKeyEnum.Background)) {
    changeSideBarKey({ dispatch, newKey: sidebarTabKeyEnum.Background, ...storeData });
  } else {
    dispatch(checkAndAutoOpenTab(storeData, allowedIcons, isGuideMode));
  }
};

export const checkAndAutoOpenTab = (isGuideMode) => (dispatch, getState) => {
  const state = getState();
  const storeData = getSidebarStoreData(state);
  const allowedIcons = getAllowedIcons(state);
  const hasOnlyOneImprintColor = getHasOneImprintColorOnly(state);
  const { studioItemType, specialTemplates } = storeData;

  const allowedIconsWithoutPreview = allowedIcons.filter((x) => x !== sidebarTabKeyEnum.Preview);
  if (isGuideMode) {
    if (allowedIconsWithoutPreview.length > 0 && !allowedIconsWithoutPreview.includes(sidebarTabKeyEnum.Background)) {
      changeSideBarKey({
        dispatch,
        newKey: allowedIconsWithoutPreview[0],
        ...storeData,
      });
      return;
    }
  } else {
    if (allowedIconsWithoutPreview.length === 1) {
      changeSideBarKey({ dispatch, newKey: allowedIcons[0], ...storeData });
      return;
    }

    if (studioItemType === studioItemTypeEnum.digital) {
      // show Background sidebar tab when entering the canvas if default template is selected
      const selectedTemplate = specialTemplates ? specialTemplates.find((template) => template.isSelected) : null;

      if (selectedTemplate && selectedTemplate.templateType === digitalTemplateType.Default) {
        changeSideBarKey({ dispatch, newKey: sidebarTabKeyEnum.Background, ...storeData });
        return;
      }
    } else {
      let tabNewKey = null;
      if (
        allowedIconsWithoutPreview.find((x) => x === sidebarTabKeyEnum.OutsideSlogan) &&
        onlyOneSloganCheck(getState(), true)
      ) {
        if (hasOnlyOneImprintColor && allowedIconsWithoutPreview.find((x) => x === sidebarTabKeyEnum.Text)) {
          tabNewKey = sidebarTabKeyEnum.Text;
        } else {
          tabNewKey = sidebarTabKeyEnum.OutsideSlogan;
        }
      } else if (
        allowedIconsWithoutPreview.find((x) => x === sidebarTabKeyEnum.Verse) &&
        onlyOneVerseCheck(getState())
      ) {
        if (hasOnlyOneImprintColor && allowedIconsWithoutPreview.find((x) => x === sidebarTabKeyEnum.Text)) {
          tabNewKey = sidebarTabKeyEnum.Text;
        } else {
          tabNewKey = sidebarTabKeyEnum.Verse;
        }
      } else if (
        allowedIconsWithoutPreview.find((x) => x === sidebarTabKeyEnum.Sentiment) &&
        onlyOneSentimentCheck(getState())
      ) {
        if (hasOnlyOneImprintColor && allowedIconsWithoutPreview.find((x) => x === sidebarTabKeyEnum.Text)) {
          tabNewKey = sidebarTabKeyEnum.Text;
        } else {
          tabNewKey = sidebarTabKeyEnum.Sentiment;
        }
      }

      if (tabNewKey) {
        changeSideBarKey({ dispatch, newKey: tabNewKey, ...storeData });
        return;
      }
    }
  }

  changeSideBarKey({ dispatch, newKey: sidebarTabKeyEnum.WhatsNext, ...storeData });
  return;
};

export const changeSideBarKey = (params) => {
  const { newKey, dispatch, canvasKey, studioItemType } = params;
  dispatch(unSelectAllImage({ canvasKey, studioItemType }));
  dispatch(unSelectAllText({ canvasKey }));

  if (studioItemType !== studioItemTypeEnum.digital && newKey !== sidebarTabKeyEnum.Text) {
    dispatch(selectImageForNonDigital({ canvasKey, sidebarTabKey: newKey }));
  } else if (studioItemType === studioItemTypeEnum.nonDigital) {
    dispatch(selectFirstLineText(canvasKey));
  } else if (studioItemType === studioItemTypeEnum.digital && newKey === sidebarTabKeyEnum.Text && !isMobileOnly) {
    dispatch(selectFirstLineText(canvasKey));
  }

  dispatch(changeSidebarTabKey(newKey));
};

export const getSideBarIconTypes = () => {
  return [
    sidebarTabKeyEnum.Background,
    sidebarTabKeyEnum.Logo,
    sidebarTabKeyEnum.OutsideSlogan,
    sidebarTabKeyEnum.Sentiment,
    sidebarTabKeyEnum.Verse,
    sidebarTabKeyEnum.Text,
    sidebarTabKeyEnum.Preview,
  ];
};
